import { getUrlDomain, nativeSdksUrl } from "./sandboxDomains";

export const documentationLinks = [
    {
        key: "nativeSdks",
        externalUrl: nativeSdksUrl,
        domain: getUrlDomain(nativeSdksUrl),
        icon: "screen",
        version: "SDK",
    },
];
